import { PriceListItem } from 'mk2/apps/plan/schemas';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

/////////////////////////////////////////////////////////////////////
// GetPlus Load

export const GET_PLUS_FETCH_TRIGGER = 'GET_PLUS_FETCH_TRIGGER';
export interface GetPlusFetchTriggerAction {
    readonly type: typeof GET_PLUS_FETCH_TRIGGER;
    readonly src?: string;
}
export const GET_PLUS_FETCH_REQUEST = 'GET_PLUS_FETCH_REQUEST';
export interface GetPlusFetchRequestAction extends APIRequestAction {
    readonly type: typeof GET_PLUS_FETCH_REQUEST;
    readonly src?: string;
}
export interface GetPlusFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        allowPayments: boolean;
        avatars: number[];
        bazaarPlusId: number;
        paymentVS: string;
        planIsActiveAndDisplaying: boolean;
        plusPrices: PriceListItem[];
    };
}
export const GET_PLUS_FETCH_SUCCESS = 'GET_PLUS_FETCH_SUCCESS';
export interface GetPlusFetchSuccessAction extends APISuccessAction<GetPlusFetchNormalizedResponse> {
    readonly type: typeof GET_PLUS_FETCH_SUCCESS;
}
export const GET_PLUS_FETCH_FAILURE = 'GET_PLUS_FETCH_FAILURE';
export interface GetPlusFetchFailureAction extends APIFailureAction {
    readonly type: typeof GET_PLUS_FETCH_FAILURE;
}

export const getPlusFetchTrigger = (src?: string): GetPlusFetchTriggerAction => ({
    type: GET_PLUS_FETCH_TRIGGER, src,
});
export const getPlusFetchApi = {
    request: (src?: string): GetPlusFetchRequestAction => ({
        type: GET_PLUS_FETCH_REQUEST, src,
    }),
    success: (response: GetPlusFetchNormalizedResponse): GetPlusFetchSuccessAction => ({
        type: GET_PLUS_FETCH_SUCCESS, response,
    }),
    failure: (error: any): GetPlusFetchFailureAction => ({
        type: GET_PLUS_FETCH_FAILURE, error,
    }),
};
